//  F0 产品头图
import { FC, useMemo } from 'react'
import clsx from 'clsx'
import { IFirstScreen, Theme } from '@/common/pd-meta-components-types'
import PdImage from '@/components/pd-image/pd-image'
import PdMedia from '@/components/pd-media/pd-media'
import WatchVideo from '@/components/pd-watch-video/pd-watch-video'
import { useMobileDetector } from '@/hooks/use-mobile-detector'
import PdTextMatchSup from '@/components/pd-text-match-sup/pd-text-match-sup'
import SemanticText from '@/components/standard/semantic-text'

const FirstScreen: FC<IFirstScreen & { titleString?: string; textColor?: string; extraContent?: React.ReactNode }> = ({
  theme,
  mediaUrl = '',
  mediaH5Url = '',
  mediaAlt = '',
  mediaH5Alt = '',
  titleUrl,
  titleString,
  subTitle,
  subTitleTag,
  textColor,
  videoUrl,
  maskColor = 'transparent',
  maskDegree = 180,
  extraContent,
}) => {
  const isMobile = useMobileDetector()
  const useMobileMedia = isMobile && !!mediaH5Url
  const maskClassName = useMemo(() => {
    if (titleUrl || subTitle) {
      switch (theme) {
        case Theme.Light:
          return 'bg-gradient-to-b from-white/50'
        case Theme.Dark:
        default:
          return 'bg-gradient-to-b from-black/50'
      }
    }
    return ''
  }, [theme, titleUrl, subTitle])

  return (
    <div className={clsx('w-full h-fit relative', `pd-theme-${theme} bg-container-primary`)}>
      <div className={clsx('w-full', 'h-[177.86vw] laptop:h-[56.25vw] overflow-hidden')}>
        <PdMedia
          src={useMobileMedia ? mediaH5Url : mediaUrl}
          alt={useMobileMedia ? mediaH5Alt : mediaAlt}
          mask={false}
        />
      </div>

      {
        <div
          className={clsx('absolute top-0 left-0 w-full h-[50%] px-6 pt-15 laptop:pt-28', 'flex flex-col items-center')}
        >
          {titleUrl && (
            <div className={clsx('w-full laptop:max-w-[24.28vw]', 'h-8 laptop:h-[3.2vw]', 'mb-3 laptop:mb-4')}>
              <PdImage src={titleUrl} object="contain" width="100%" height="100%" enableMask={false} priority={true} />
            </div>
          )}
          {titleString && (
            <h1
              className={clsx('max-w-200 mx-auto', 'break-words', 'text-fc-primary pd-first-title')}
              style={{ color: textColor }}
            >
              <PdTextMatchSup className="" supClassName="" text={titleString}></PdTextMatchSup>
            </h1>
          )}
          {subTitle && (
            <SemanticText
              as={subTitleTag}
              defaultTag="p"
              className={clsx(
                'max-w-200 mx-auto',
                'mb-3 laptop:mb-4',
                'break-words',
                'text-fc-primary text-lg laptop:text-xl'
              )}
              style={{ color: textColor }}
            >
              <PdTextMatchSup className="" supClassName="" text={subTitle}></PdTextMatchSup>
            </SemanticText>
          )}
          {videoUrl && (
            <WatchVideo
              className="px-[3.2vw] py-[2.13vw] laptop:px-[0.8333vw] laptop:py-[0.4166vw]"
              textClassName={'text-[3.73vw] laptop:text-[0.73vw]'}
              videoUrl={videoUrl}
            />
          )}
          {extraContent && extraContent}
        </div>
      }
    </div>
  )
}

export default FirstScreen
